export default function (phone) {
  phone = phone.replace(/\+7/g, '')
  phone = phone.replace(/\D+/g, '')

  const operators = ['705', '777', '771', '776', '700', '708', '701', '702', '775', '778', '707', '747', '706']
  const currentOperator = phone.substring(0, 3)

  for (let i = 0; i < operators.length; i++) {
    if (currentOperator === operators[i] || phone.length < 3) {
      return true
    }
  }

  return false
}
